import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, opts } from './shared';

const FIELDS = [
  ['spike_multiplier', 'Spike: × previous period', 0.5],
  ['spike_min_pts', 'Spike: min pts', 10],
  ['referral_min', 'Referral farm: min referrals', 1],
  ['referral_paying_ratio', 'Referral farm: paying share below (0–1)', 0.05],
  ['like_ring_min', 'Like ring: likes from one person', 1],
  ['tier_candidate_min_pts', 'Tier candidate: min pts', 10],
  ['tier_candidate_order_share', 'Tier candidate: order share (0–1)', 0.05],
];

// Per-region flag levels; only editable when a single region is selected.
export function WatchThresholds({ region, thresholds, onSaved }) {
  const [draft, setDraft] = useState(thresholds);
  useEffect(() => setDraft(thresholds), [thresholds]);
  if (!thresholds) return <p className="font-mono text-[11px] text-[#6B8E73]" data-testid="watch-thresholds-hint">// Pick DMV or NJ to adjust that region&apos;s flag levels.</p>;
  const dirty = JSON.stringify(draft) !== JSON.stringify(thresholds);
  const save = async () => {
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, Number(draft[k])]));
      const { data } = await axios.put(`${API}/thresholds/${region}`, body, opts);
      toast.success('Flag levels saved');
      onSaved(data.thresholds);
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || 'Save failed'); }
  };
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="watch-thresholds">
      {FIELDS.map(([k, label, step]) => (
        <label key={k} className="font-mono text-[10px] text-[#6B8E73] uppercase flex flex-col gap-1">
          {label}
          <input type="number" step={step} min="0" value={draft[k]} onChange={(e) => setDraft({ ...draft, [k]: e.target.value })}
            className="bg-[#050003] border border-[#2A0F3D] focus:border-[#39FF14] font-mono text-sm px-2 py-1 text-white outline-none" data-testid={`watch-threshold-${k}`} />
        </label>
      ))}
      <div className="flex items-end">
        <button type="button" disabled={!dirty} onClick={save} className="px-3 py-1.5 font-mono text-xs border border-[#39FF14] text-[#39FF14] disabled:opacity-40" data-testid="watch-thresholds-save">Save levels</button>
      </div>
    </div>
  );
}
